import React, { FC, useEffect, useState } from 'react';

import { updateGtmConsent } from '../tagging';
import CookieConsent from './CookieConsent';
import { ConsentState, getCookieConsentStateFromCookie, setCookieConsentStateInCookie } from './service';

const setGtmConsent = (consent: ConsentState | null) => {
  if (consent?.status) updateGtmConsent(consent);
};

interface CookieConsentWrapperProps {
  url: string | null;
}

const CookieConsentWrapper: FC<CookieConsentWrapperProps> = ({ url }) => {
  const [consent, setConsent] = useState<ConsentState | null>(null);
  const [cookie, setCookie] = useState(false);

  useEffect(() => {
    if (!cookie) {
      const consentFromCookie = getCookieConsentStateFromCookie();
      setConsent(consentFromCookie);
      setGtmConsent(consentFromCookie);
      setCookie(true);
    }
  }, [cookie]);

  const handleSetConsent = (consent: ConsentState) => {
    setCookieConsentStateInCookie(consent);
    setConsent(consent);
    setGtmConsent(consent);
  };

  return <CookieConsent display={consent === null} consent={consent} setConsent={handleSetConsent} url={url} />;
};

export default CookieConsentWrapper;
